module.exports = __webpack_public_path__ + "img/46.f0f8d788.png";